import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { clear } from "@testing-library/user-event/dist/clear";

import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";

const AddConferenceCoupon = () => {
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    //const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    // const [workShopCategory, setWorkShopCategory] = useState('');
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [selectedWorkShop, setSelectedWorkShop] = useState('');
    const [selectedValue, setSelectedValue] = useState('percentage');
    const [prefix, setPrefix] = useState('');
    const [count, setCount] = useState(0);
    const [generatedCoupons, setGeneratedCoupons] = useState([]);
    const [conferenceCoupon, setCoferenceCoupon] = useState([]);
    const [assignCategoye, setAssignCategoye] = useState([]);
    const [error, setError] = useState('');
    const [addConferenceCouponForm, setAddConferenceCouponForm] = useState({
        event_name: eventName,
        conference_coupon_name: "",
        conference_code: "",
        descriptions: "",
        conference_coupon_value_fixed: "",
        conference_coupon_percentage: "",

        error_list: [],
    });

 useEffect(() => {
        axios.get(`api/conference-applied-coupon?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.conferenceCoupen;
                setCoferenceCoupon(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    const handleChangeMulti = (event: SelectChangeEvent<typeof assignCategoye>) => {
        const {
            target: { value },
        } = event;

        if (value.includes("selectAll")) {
            // If "Select All" is selected and not all items are currently selected, select all.
            // If all items are already selected, unselect all.
            setAssignCategoye(
                assignCategoye.length !== conferenceCoupon.length
                    ? conferenceCoupon.map((workshop) => workshop.id)
                    : []
            );
        } else {
            // Update assignCategoye based on individual selections
            setAssignCategoye(
                // On autofill we get a stringified value.
                typeof value === "string" ? value.split(",") : value
            );
        }
    };


  

    useEffect(() => {
        const generateCoupons = () => {
            const coupons = [];
            const uniqueCodes = new Set();

            while (coupons.length < count) {
                const randomCode = generateRandomCode();
                const couponCode = `${prefix}${randomCode}`;

                if (!uniqueCodes.has(couponCode)) {
                    uniqueCodes.add(couponCode);
                    coupons.push(couponCode);
                }
            }

            setGeneratedCoupons(coupons);
        };

        generateCoupons();
    }, [prefix, count]);

    const generateRandomCode = () => {
        return Math.random().toString(36).substring(2, 8).toUpperCase();
    };

    const handleInput = (e) => {
        e.persist();
        setAddConferenceCouponForm({ ...addConferenceCouponForm, [e.target.name]: e.target.value });
    }


    const handleChange = (event) => {
        setSelectedWorkShop(event.target.value);
        

    };
    const handleChangeSelectAmountType = (event) => {
        setSelectedValue(event.target.value);
        setError('');
    };

    const handleStartTime = (event) => {
        setStartTime(event.target.value);
    };

    const handleEndTime = (event) => {
        setEndTime(event.target.value);
    };



    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    // const handleWorkShopCategory = (e) => {
    //     setWorkShopCategory(e.target.value);
    // }

    const submitWorkShop = (e) => {


        e.preventDefault();

        const data = {
            eventid,
            event_name: addConferenceCouponForm.event_name,
            conference_coupon_name: addConferenceCouponForm.conference_coupon_name,

            conference_coupon_percentage: addConferenceCouponForm.conference_coupon_percentage,
            conference_coupon_value_fixed: addConferenceCouponForm.conference_coupon_value_fixed,
            descriptions: addConferenceCouponForm.descriptions,
            expireDate: selectedDate,
            coupon_codes: generatedCoupons,
            coupon_apply_conferece: selectedWorkShop,
            amount_type: selectedValue,
            prefix,
            coupon_qty: count,
        }
       // Validate specific conditions

    if (data.conference_coupon_name.trim() === "") {
        setError('Conference name is required');
        return;
    }
    if (selectedValue === 'percentage' && !addConferenceCouponForm.conference_coupon_percentage) {
        setError('Percentage value is required');
        return;
    } else if (selectedValue === 'fixed' && !addConferenceCouponForm.conference_coupon_value_fixed) {
        setError('Fixed value is required');
        return;
    }
    
    if (data.coupon_apply_conferece === "") {
        setError('Select the conference');
        return;
    }
    if (data.expireDate === "") {
        setError('Expire Date is required');
        return;
    }
    
    if (data.prefix === "") {
        setError('prefix name is required');
        return;
    }
    if (data.coupon_qty === "") {
        setError('Number of coupon is required');
        return;
    }
     axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/conference-create-coupon-store`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    history.push('/admin/conference/manage-coupon');
                }
                else {

                    setAddConferenceCouponForm({ ...addConferenceCouponForm, error_list: res.data.validate_error })

                }

            });


        });


    }


    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Add Conference Coupon
                        </Typography>
                        <Box component="form" onSubmit={submitWorkShop} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} >
                                    <TextField
                                        disabled
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Evnet Name"
                                        autoFocus
                                        name='event_name' onChange={handleInput}
                                        defaultValue={eventName || ""}
                                    />
                                </Grid>


                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Coupon Name"
                                        autoFocus
                                        name='conference_coupon_name' onChange={handleInput}
                                    />
                                </Grid>


                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Amount Type</InputLabel>
                                        <Select
                                            label="Amount Type"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedValue}
                                            onChange={handleChangeSelectAmountType}
                                        >
                                            <MenuItem value="percentage">Percentage</MenuItem>
                                            <MenuItem value="fixed">Fixed</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {selectedValue === 'percentage' && (
                                    <Grid item xs={6}>
                                        {/* Render input for percentage */}
                                        <TextField
                                            autoComplete="given-name"
                                            required
                                            fullWidth
                                            label=" Coupon Value Percentage"
                                            autoFocus
                                            name="conference_coupon_percentage"
                                            onChange={handleInput}
                                        />
                                    </Grid>

                                )}

                                {selectedValue === 'fixed' && (
                                    <Grid item xs={6}>
                                        {/* Render input for amount */}
                                        <TextField
                                            autoComplete="given-name"
                                            required
                                            fullWidth
                                            label="Coupon Value Fixed"
                                            autoFocus
                                            name="conference_coupon_value_fixed"
                                            onChange={handleInput}
                                        />
                                    </Grid>
                                )}




                                <Grid item xs={12} >

                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth

                                        label="Add Descriptions"
                                        autoFocus
                                        name='descriptions' onChange={handleInput}
                                        multiline
                                        rows={6}
                                    />

                                </Grid>
                                <Grid item xs={6}>

                                    <FormControl fullWidth>
                                        <InputLabel id="select-label">Select Conference</InputLabel>
                                        <Select
                                            labelId="select-label"
                                            id="select"
                                            value={selectedWorkShop}
                                            label="Select Workshop"
                                            onChange={handleChange}
                                        >
                                            {conferenceCoupon.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>{item.conferencecategory.conference_category_title} : {item.conference_name} - {item.conference_day}</MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        id="date"
                                        fullWidth
                                        label="Expire Date"
                                        type="date"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>



                                <Grid item xs={6}>

                                    <TextField
                                        fullWidth
                                        label="Coupon Prefix"
                                        variant="outlined"
                                        inputProps={{ maxLength: 3 }}
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        style={{ marginRight: '10px' }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Number of Coupons"
                                        variant="outlined"
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={count}
                                        onChange={(e) => {
                                            const maxLength = 2;
                                            const value = e.target.value.slice(0, maxLength);
                                            setCount(value);
                                        }}
                                        style={{ marginRight: '10px' }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6" style={{ marginTop: '20px' }}>
                                        Generated Coupons:
                                    </Typography>
                                    <ul>
                                        {generatedCoupons.map((coupon, index) => (
                                            <li key={index}>{coupon}</li>
                                        ))}
                                    </ul>
                                </Grid>



                            </Grid>
                            {error && (
                                <Grid item xs={12}>
                                    <Typography color="error">{error}</Typography>
                                </Grid>
                            )}

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5,backgroundColor: backGroundButtonByEvent, }} >
                                    Add Conference coupon
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div >
    );
}
export default AddConferenceCoupon;
